import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { ProjectDetailComponent } from "@modules/user/project/pages/project-detail/project-detail.component";
import { ProjectService } from "@modules/user/project/services/project.service";
import { map } from "rxjs/operators";
import { Project } from "@modules/user/project/models/project";

@Injectable()
export class CanDeactivateGuard  {

	constructor(private projectService: ProjectService) {

	}

	canDeactivate(component: ProjectDetailComponent,
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot) {

		if (component.isEditable) {

			if (component.projectForm.dirty && !confirm('Aangebrachte wijzigingen worden niet opgeslagen. Weet u het zeker?')) {

				return false;
			}

			const project: Project = component.projectForm.getRawValue();

			return this.projectService.unlockProject(project).pipe(map(e => {

				return true;
			}));
		}

		return true;
	}
} 